import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-no",
  "use": "icon-icon-no-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-no\">\n  <path fill=\"#ed2939\" d=\"M0 0h512v512H0z\" />\n  <path fill=\"#fff\" d=\"M128 0h128v512H128z\" />\n  <path fill=\"#fff\" d=\"M0 192h512v128H0z\" />\n  <path fill=\"#002664\" d=\"M160 0h64v512h-64z\" />\n  <path fill=\"#002664\" d=\"M0 224h512v64H0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol